import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Navbar, Sidebar, Footer } from './components'

import {
  Home,
  SingleProdutos,
  Cart,
  Checkout,
  Error,
  Sobre,
  Produtos,
  PrivateRoute,
} from './pages'

function App() {
  return (
    <Router>
      <Navbar />
      <Sidebar />
      <Switch>
        <Route exact path='/'>
          <Home />
        </Route>
        <Route exact path='/sobre'>
          <Sobre />
        </Route>
        <Route exact path='/cart'>
          <Cart />
        </Route>
        <Route exact path='/produtos'>
          <Produtos />
        </Route>
        <Route exact path='/produtos/:id' children={<SingleProdutos />} />
        <PrivateRoute exact path='/checkout'>
          <Checkout />
        </PrivateRoute>
        <Route path='*'>
          <Error />
        </Route>
      </Switch>
      <Footer />
    </Router>
  )
}

export default App
